<template>
  <AppGenericInput
    v-model="givenValue"
    v-bind="[
      inputProps,
      {
        items: licenceCategories,
        itemText: 'name',
        itemValue: 'id',
        label
      }
    ]"
    component-name="v-select"
    :inherit-listeners="$listeners"
  >
    <template #append-outer><slot name="append-outer"/></template>
  </AppGenericInput>
</template>
<script>
import AppGenericInput from "@AppSelects/AppGenericInput.vue";
import { useLicenceCategoryHelper } from "@composables/masterdata/person/licenceCategories";
import addMissingSelectValue from "@/utils/inputs/add_missing_select_value";

export default {
  name: "AppSelectLicenceCategory",
  components: { AppGenericInput },
  props: {
    value: {
      type: [Array, String],
      default: null
    },
    inputProps: {
      type: Object,
      default: () => ({})
    },
    limitSelection: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: "Licence categories"
    }
  },
  setup() {
    return {
      ...useLicenceCategoryHelper()
    };
  },
  computed: {
    givenValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    },
    licenceCategories() {
      let licenses = this.masterLicenceCategoriesActive;
      if (this.limitSelection.length) {
        licenses = licenses.filter(l => this.limitSelection.includes(l.id));
      }

      licenses = addMissingSelectValue(this.inputValue, licenses, {
        rawItems: this.masterLicenceCategories,
        keyValue: "id",
        multiple: this.inputProps.multiple,
        returnObject: this.inputProps.returnObject
      });

      return licenses;
    }
  }
};
</script>
